import { getHandleResponse } from "helpers/getHandleResponse";
import { getAuthHeader } from "helpers/getAuthHeader";

const API_BASE_URL = process.env.REACT_APP_URL;

const makeRequest = async (endpoint, method, data = null) => {
    const requestOptions = { method, headers: getAuthHeader() };
    if (data) requestOptions.body = JSON.stringify(data);
    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, requestOptions);
        const result = await getHandleResponse(response);
        return { error: false, data: result };
    } catch (error) {
        return { error: true, data: error.message };
    }
};

const makeBlobDownload = async (endpoint, method = 'GET', body = null, filename = 'reporte.xlsx') => {
    const requestOptions = {
        method,
        headers: {
            Authorization: getAuthHeader().Authorization,
            ...(body ? { 'Content-Type': 'application/json' } : {})
        },
        ...(body ? { body: JSON.stringify(body) } : {})
    };
    try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, requestOptions);
        if (!response.ok) throw new Error('Error al descargar reporte');
        const disposition = response.headers.get('Content-Disposition');
        let downloadName = filename;
        if (disposition) {
            const match = disposition.match(/filename="?([^"]+)"?/);
            if (match) downloadName = match[1];
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = downloadName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        return { error: false };
    } catch (error) {
        return { error: true, data: error.message };
    }
};

const buildQueryString = (params) => {
    const filteredParams = Object.entries(params)
        .filter(([_, value]) => value !== null && value !== undefined && value !== '')
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    return new URLSearchParams(filteredParams).toString();
};

const paymentService = {
    // Obtener calendario de pagos
    getPaymentCalendar: (params = {}) => {
        const queryString = buildQueryString(params);
        return makeRequest(`/api/payments/calendar${queryString ? `?${queryString}` : ''}`, "GET");
    },

    // Marcar pago como realizado (solo admin)
    markPaymentAsDone: (id, data) => makeRequest(`/api/payments/${id}/mark-paid`, "PATCH", data),

    // ── NUEVO: Reporte Top de gastos ─────────────────────────────────────────
    /**
     * Obtiene el top de gastos agrupado por proveedor, tipo_gasto o centro_costo
     * @param {Object} params - { top?, agrupar_por?, fecha_inicio?, fecha_fin? }
     */
    getTopSpendingReport: (params = {}) => {
        const queryString = buildQueryString(params);
        return makeRequest(`/api/payments/reports/top-spending${queryString ? `?${queryString}` : ''}`, "GET");
    },

    // ── NUEVO: Descarga Excel de pagos de la semana ───────────────────────────
    /**
     * Descarga un .xlsx con los pagos del período indicado
     * @param {Object} params - { fecha_inicio?, fecha_fin? }
     */
    downloadWeeklyPaymentsExcel: (params = {}) => {
        const queryString = buildQueryString(params);
        const today = new Date().toISOString().split('T')[0];
        return makeBlobDownload(
            `/api/payments/reports/weekly-excel${queryString ? `?${queryString}` : ''}`,
            'GET',
            null,
            `pagos_semana_${today}.xlsx`
        );
    },
};

export default paymentService;